import React from 'react';
import * as Typography from '@/components/shadcn/typography';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/shadcn/accordion.tsx';
import { ContentSection } from '@/utils/tos';

interface Props {
  data: {
    title: string;
    date: string;
    sections: ContentSection[];
  };
  sections: ContentSection[];
}

const Content = ({ data, sections }: Props) => {
  return (
    <div>
      <div className="pb-1 pt-4 text-neutral-400">
        <p>Last Updated: {data.date}</p>
      </div>
      <Accordion type="single" collapsible className="w-full">
        <Typography.H4>{data.title}</Typography.H4>
        {sections.map(section => (
          <AccordionItem key={section.title} value={section.title}>
            <AccordionTrigger>{section.title}</AccordionTrigger>
            <AccordionContent>
              {section.list && <Typography.List list={section.list} />}
              {section.content?.map(content => (
                <Typography.P key={content}>{content}</Typography.P>
              ))}
              {section.nestedItems?.map(nestedItem => (
                <div className="py-3" key={nestedItem.title}>
                  <Typography.H4>{nestedItem.title}</Typography.H4>
                  {nestedItem.description && (
                    <Typography.P>{nestedItem.description}</Typography.P>
                  )}
                  {nestedItem.list && (
                    <Typography.List list={nestedItem.list} />
                  )}
                  {nestedItem.content?.map((content, index) => (
                    <p
                      key={index.toString()}
                      dangerouslySetInnerHTML={{ __html: content }}
                      className="[&>a]:text-azure-500"
                    />
                  ))}
                </div>
              ))}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default Content;
